import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { GridColumn, GridRow, HSpacing, Title, VSpacingContainer } from '@hh.ru/magritte-ui';
import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';

import CardEdProgram from 'src/components/CardEdProgram/CardEdProgram';
import EmptyStateCourses from 'src/components/EmptyState/EmptyStateCourses';
import { ProfessionScrollAnchors } from 'src/models/pages/profession';
import { EdProgramCoursePurpose, EdProgramEducationPurpose } from 'src/types/EdProgram';

const TrlKeys = {
    profession: 'career-platform.profession.sections.courses.profession.title',
    skills: 'career-platform.profession.sections.courses.skills.title',
    higherEducation: 'career-platform.profession.sections.courses.higherEducation.title',
};

const SectionCourses: TranslatedComponent = ({ trls }) => {
    const {
        [EdProgramCoursePurpose.Profession]: profession,
        [EdProgramCoursePurpose.Skill]: skills,
        [EdProgramEducationPurpose.HigherEducation]: higherEducation,
    } = useSelectorNonNullable((state) => state.pageProfession.courses);

    if (!profession.length && !skills.length && !higherEducation.length) {
        return <EmptyStateCourses />;
    }

    return (
        <VSpacingContainer default={40}>
            {!!profession.length && (
                <section id={ProfessionScrollAnchors.Professions}>
                    <Title Element="h2" size="medium" dataQaTitle="section-courses-professions-title">
                        {trls[TrlKeys.profession]}
                    </Title>
                    <HSpacing default={24} />
                    <GridRow rowGap={24}>
                        {profession.map((item) => (
                            <GridColumn
                                key={item.id}
                                xs={4}
                                s={8}
                                m={profession.length <= 2 ? 6 : 4}
                                xl={3}
                                flexibleContent
                            >
                                <CardEdProgram edProgram={item} />
                            </GridColumn>
                        ))}
                    </GridRow>
                </section>
            )}
            {!!skills.length && (
                <section id={ProfessionScrollAnchors.Skills}>
                    <Title Element="h2" size="medium" dataQaTitle="section-courses-skills-title">
                        {trls[TrlKeys.skills]}
                    </Title>
                    <HSpacing default={24} />
                    <GridRow rowGap={24}>
                        {skills.map((item) => (
                            <GridColumn key={item.id} xs={4} s={8} m={4} xl={3} flexibleContent>
                                <CardEdProgram edProgram={item} />
                            </GridColumn>
                        ))}
                    </GridRow>
                </section>
            )}
            {!!higherEducation.length && (
                <section id={ProfessionScrollAnchors.HigherEducation}>
                    <Title Element="h2" size="medium" dataQaTitle="section-courses-highereducation-title">
                        {trls[TrlKeys.higherEducation]}
                    </Title>
                    <HSpacing default={24} />
                    <GridRow rowGap={24}>
                        {higherEducation.map((item) => (
                            <GridColumn key={item.id} xs={4} s={8} m={4} xl={3} flexibleContent>
                                <CardEdProgram edProgram={item} />
                            </GridColumn>
                        ))}
                    </GridRow>
                </section>
            )}
        </VSpacingContainer>
    );
};

export default translation(SectionCourses);
